import React, { memo } from 'react';

const MapText = ({ key, text, style = {} }) => (
  <div key={key} style={{ ...style }}>
    {text}
  </div>
);

export default memo(MapText);
